/* This file is autogenerated, see readme.md for instructions */
import ListSvgIcon from '@bloomreach/banana-theme/icons/list.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ListIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ListSvgIcon />
    </Icon>
  );
});

ListIcon.displayName = 'ListIcon';

export default ListIcon;
